import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../../components/button/ButtonPrimary";
import {
  setArticleSummary,
  setBookmarkArticle,
  setSummarizePopup,
  setSummaryInfoData,
  setUrl,
} from "../../../../redux/features/dataSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../../../components/loader";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { openaiAPI } from "../../../../apis";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../../functions/isMobile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateComponent from "../../../../components/DateComponent";
import { getRegularDate } from "../../../../functions/time";
import {
  articleSummary1,
  articleSummary2,
  customSummaryMessage,
  summaryMessage,
} from "../../../../constants";

const Summarize = (props) => {
  const isMobile = useIsMobile();

  const {
    setSaveBookmarkPopup,
    desc,
    setDesc,
    isDescExternal,
    setIsDescExternal,
    summaryText,
    setSummaryText,
    summarizePopupNa,
    setSummarizePopupNa,
  } = props;
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [changeTooltip, setChangeTooltip] = useState(false);
  const [calendarPopup, setCalendarPopup] = useState(false);
  const [customDesc, setCustomDesc] = useState("");
  const [hasDescBeenSet, setHasDescBeenSet] = useState(false);

  const [position, setPosition] = useState({
    marginTop: -44,
    marginLeft: -41,
  });
  const [summaryInfo, setSummaryInfo] = useState({
    publisher: "",
    published_date: "",
    url: "",
    title: "",
  });

  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const { url, summaryInfoData } = useSelector((state) => state.data);

  const [localPublisher, setLocalPublisher] = useState(
    summaryInfoData.publisher
  );
  const [localPublishedDate, setLocalPublishedDate] = useState(
    summaryInfoData.published_date
  );
  const [localTitle, setLocalTitle] = useState(summaryInfoData.title);
  const [localURL, setLocalURL] = useState(summaryInfoData.url);

  const setErrorMessage = () => {
    setDesc(
      "We're sorry, we could not fetch the content of this article. Try using the Custom Summarizer in the toolbar above by manually opening the article, copy its content, paste it into the Custom Summarizer, then click Generate. You will be able to save it as a separate bookmark."
    );
    setCustomDesc(
      "We're sorry, we could not fetch the content of this article. Try using the Custom Summarizer in the toolbar above by manually opening the article, copy its content, paste it into the Custom Summarizer, then click Generate. You will be able to save it as a separate bookmark."
    );
    setError(true);
  };

  const getData = async () => {
    if (url) {
      try {
        const res = await axios.post(`${openaiAPI.articleSummary}`, {
          url: url,
        });

        const bullets = Object.keys(res.data.summary)
          .filter((key) => key.startsWith("bullet"))
          .map((key) => res.data.summary[key]);
        setDesc(bullets.join("\n\n"));
        setCustomDesc(bullets.join("\n\n"));
        if (
          res.data?.error?.includes(
            "An error occurred while generating the summary"
          )
        ) {
          setErrorMessage();
        }
      } catch (error) {
        console.log(error);
        setErrorMessage();
      }
    }
    setLoading(false);
  };

  const handleCopy = () => {
    const getSummaryData = isDescExternal ? summaryInfo : summaryInfoData;
    const copiedData = `Publisher: ${getSummaryData.publisher} \nTitle: ${getSummaryData.title} \nPublished date: ${getSummaryData.published_date} \nLink: ${getSummaryData.url} \n\nSummary: ${desc}`;
    navigator.clipboard.writeText(copiedData).catch((error) => {
      console.error("Unable to copy data to clipboard:", error);
    });
    setChangeTooltip(true);
  };

  const tooltipTitle = changeTooltip
    ? "Copied to clipboard"
    : "Copy to clipboard";

  const handleMouseOut = (event) => {
    setTimeout(() => {
      const fromElement = event.relatedTarget;
      const tooltipButton = document.getElementById("tooltipButton");

      if (!tooltipButton?.contains(fromElement)) {
        setChangeTooltip(false);
      }
    }, 1000);
  };
  const handleSave = () => {
    if (
      !summaryInfoData.publisher ||
      !summaryInfoData.title ||
      !summaryInfoData.url
    ) {
      toast.error("Publisher, Title, and URL are mandatory!");
      return;
    }
    dispatch(setBookmarkArticle(true));
    try {
      let new_date;
      if (isDescExternal) {
        new_date = new Date(summaryInfo.published_date);
        if (summaryInfo.published_date === "") {
          new_date = null;
        }
      } else {
        new_date = new Date(summaryInfoData.published_date);
        if (isNaN(new_date.getTime())) {
          throw new Error("Invalid date");
        }
      }
      dispatch(setArticleSummary(desc));
      setSaveBookmarkPopup(true);
    } catch {
      toast.error("Please Enter a valid date");
    }
  };

  const handleClose = () => {
    setDesc("");
    setSummaryText("");
    dispatch(setSummaryInfoData({}));
    setIsDescExternal(false);
    dispatch(setUrl(""));
    setSummarizePopupNa(false);
    dispatch(setSummarizePopup(false));
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  const setDate = (date) => {
    let new_date = new Date(date);
    if (isNaN(new_date.getTime())) {
      new_date = null;
    }
    const updatedValue = {
      ...summaryInfoData,
      published_date: getRegularDate(new_date),
    };
    dispatch(setSummaryInfoData(updatedValue));
    setLocalPublishedDate(getRegularDate(new_date));
  };

  const reqDate = () => {
    let new_date = new Date(summaryInfoData.published_date);
    if (isNaN(new_date.getTime())) {
      new_date = null;
    }
    console.log("date", new_date);
    return new_date;
  };

  useEffect(() => {
    getData();
  }, [url]);

  const handlePublishedDateChange = (e) => {
    setLocalPublishedDate(e.target.value);
  };

  const handleUpdateDateState = (e) => {
    let new_date = new Date(e.target.value);
    if (isValidDate(new_date)) {
      new_date = getRegularDate(new_date);
      setLocalPublishedDate(new_date);
      dispatch(
        setSummaryInfoData((...prev) => [{ ...prev, published_date: new_date }])
      );
    } else {
      setLocalPublishedDate("");
      dispatch(
        setSummaryInfoData((...prev) => [{ ...prev, published_date: null }])
      );
    }
  };

  const isValidDate = (d) => {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      if (isNaN(d.getTime())) return false;
      else return true;
    }
    return false;
  };

  const handleInputChange = (e, change) => {
    change(e.target.value);
  };

  const updateGlobalState = () => {
    const newSummaryInfo = {
      publisher: localPublisher,
      published_date: localPublishedDate,
      title: localTitle,
      url: localURL,
    };
    dispatch(setSummaryInfoData(newSummaryInfo));
  };

  const handleChange = (e) => {
    setCustomDesc(e.target.value);
  };

  const handleCustomDescChange = () => {
    let currentText = customDesc;
    currentText = currentText.replace(/\n{3,}/g, "\n\n");
    setCustomDesc(currentText);
  };

  const updateSummary = () => {
    let currentText = customDesc;
    currentText = currentText.replace(/\n{3,}/g, "\n\n");
    setDesc(currentText);
  };

  useEffect(() => {
    if (isDescExternal && !hasDescBeenSet) {
      setCustomDesc(desc);
      setHasDescBeenSet(true);
    }
  }, [isDescExternal, desc, hasDescBeenSet]);

  return (
    summarizePopupNa && (
      <>
        <div className="bg-dark" />
        {!isMobile ? (
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
          >
            <div className="new-summarize-popup">
              <div className="popup-card">
                <>
                  <CloseIcon className="cross" onClick={handleClose} />
                  {loading && <p className="mt-2">{summaryMessage}</p>}
                  {loading ? (
                    <CustomLoader height="20vh" style={true} />
                  ) : (
                    <>
                      <div className="first-half">
                        <p className="popup-title">AI-Generated Summary</p>
                        {desc &&
                          !error &&
                          (isDescExternal ? (
                            <p>{customSummaryMessage}</p>
                          ) : (
                            <>
                              <p>{articleSummary1}</p>
                              <p>{articleSummary2}</p>
                            </>
                          ))}
                        {!error && (
                          <div className="title-container">
                            <div className="mt-1 summary-boxes">
                              <div className="space-between">
                                <span className="first-col">Source:</span>{" "}
                                <input
                                  type="text"
                                  disabled={!editing}
                                  value={localPublisher}
                                  onChange={(e) =>
                                    handleInputChange(e, setLocalPublisher)
                                  }
                                  onBlur={updateGlobalState}
                                  className="summary-box"
                                />
                              </div>
                              <div></div>
                            </div>
                            <div className="mt-1 summary-boxes">
                              <div className="space-between">
                                <span className="first-col">
                                  Published Date:
                                </span>{" "}
                                <div className="space-between-date">
                                  <input
                                    type="text"
                                    disabled={!editing}
                                    value={localPublishedDate}
                                    onChange={handlePublishedDateChange}
                                    onBlur={handleUpdateDateState}
                                    className="summary-box"
                                  />
                                  <Tooltip title="View calendar">
                                    <CalendarMonthIcon
                                      style={{ cursor: "pointer" }}
                                      className=""
                                      onClick={() => setCalendarPopup(true)}
                                    />
                                  </Tooltip>
                                </div>
                              </div>
                              <div></div>
                            </div>{" "}
                            <div className="mt-1 summary-boxes">
                              <div className="space-between">
                                <span className="first-col">Title:</span>{" "}
                                <input
                                  type="text"
                                  value={localTitle}
                                  onChange={(e) =>
                                    handleInputChange(e, setLocalTitle)
                                  }
                                  onBlur={updateGlobalState}
                                  disabled={!editing}
                                  className="summary-box"
                                />
                              </div>
                              <div></div>
                            </div>
                            <div className="mt-1 summary-boxes">
                              <div className="space-between">
                                <span className="first-col">URL:</span>{" "}
                                <input
                                  type="text"
                                  value={localURL}
                                  onChange={(e) =>
                                    handleInputChange(e, setLocalURL)
                                  }
                                  onBlur={updateGlobalState}
                                  disabled={!editing}
                                  className="summary-box"
                                />
                              </div>
                              <div></div>
                            </div>
                          </div>
                        )}
                        {!editing ? (
                          <div className="comment-container">
                            <div className="comment-content">
                              {customDesc && customDesc.length > 0 ? (
                                <ul>
                                  {customDesc
                                    .split("\n\n")
                                    .map((bullet, index) => (
                                      <li
                                        key={index}
                                        className={error ? "error" : "mb-2"}
                                      >
                                        {bullet}
                                      </li>
                                    ))}
                                </ul>
                              ) : (
                                <p className={error ? "error" : "desc"}>
                                  {desc}
                                </p>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="comment-container flow">
                            <textarea
                              className="desc edit-textarea"
                              value={customDesc}
                              onBlur={updateSummary}
                              onChange={handleChange}
                            />
                          </div>
                        )}
                      </div>
                      <div className="save-actions">
                        <div />
                        <div className="flex-btn mt-2">
                          {desc && !error && (
                            <>
                              <div className="flex-button button-group">
                                <div className="flex">
                                  {/* <ButtonPrimary
                                  className="mr-2 grey"
                                  outline
                                  text="Regenerate"
                                  onClick={handleRegenerate}
                                /> */}
                                  <Tooltip title={tooltipTitle}>
                                    <button
                                      id="tooltipButton"
                                      className="btn-copy outlined mr-2"
                                      onClick={handleCopy}
                                      onMouseOut={handleMouseOut}
                                    >
                                      <p>Copy</p>
                                    </button>
                                  </Tooltip>
                                  <ButtonPrimary
                                    text="Edit"
                                    className="mr-2 grey"
                                    outline
                                    onClick={() => {
                                      setDesc(desc);
                                      handleCustomDescChange();
                                      setEditing(!editing);
                                    }}
                                  />
                                </div>
                                <ButtonPrimary
                                  text="Save"
                                  className="close"
                                  onClick={handleSave}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              </div>
            </div>
          </Draggable>
        ) : (
          <div className="new-summarize-popup">
            <div className="popup-card">
              <>
                <CloseIcon className="cross" onClick={handleClose} />
                {loading && <p className="mt-2">{summaryMessage}</p>}
                {loading ? (
                  <CustomLoader height="20vh" style={true} />
                ) : (
                  <>
                    <div className="first-half">
                      <p className="popup-title">AI-Generated Summary</p>
                      {desc &&
                        !error &&
                        (isDescExternal ? (
                          <p>{customSummaryMessage}</p>
                        ) : (
                          <>
                            <p>{articleSummary1}</p>
                            <p>{articleSummary2}</p>
                          </>
                        ))}
                      {!error && (
                        <div className="title-container">
                          <div className="mt-1 summary-boxes">
                            <div className="space-between">
                              <span className="first-col">Source:</span>{" "}
                              <input
                                type="text"
                                disabled={!editing}
                                value={localPublisher}
                                onChange={(e) =>
                                  handleInputChange(e, setLocalPublisher)
                                }
                                onBlur={updateGlobalState}
                                className="summary-box"
                              />
                            </div>
                            <div></div>
                          </div>
                          <div className="mt-1 summary-boxes">
                            <div className="space-between">
                              <span className="first-col">Published Date:</span>{" "}
                              <div className="space-between-date">
                                <input
                                  type="text"
                                  disabled={!editing}
                                  value={localPublishedDate}
                                  onChange={handlePublishedDateChange}
                                  onBlur={handleUpdateDateState}
                                  className="summary-box"
                                />
                                <Tooltip title="View calendar">
                                  <CalendarMonthIcon
                                    style={{ cursor: "pointer" }}
                                    className=""
                                    onClick={() => setCalendarPopup(true)}
                                  />
                                </Tooltip>
                              </div>
                            </div>
                            <div></div>
                          </div>{" "}
                          <div className="mt-1 summary-boxes">
                            <div className="space-between">
                              <span className="first-col">Title:</span>{" "}
                              <input
                                type="text"
                                value={localTitle}
                                onChange={(e) =>
                                  handleInputChange(e, setLocalTitle)
                                }
                                onBlur={updateGlobalState}
                                disabled={!editing}
                                className="summary-box"
                              />
                            </div>
                            <div></div>
                          </div>
                          <div className="mt-1 summary-boxes">
                            <div className="space-between">
                              <span className="first-col">URL:</span>{" "}
                              <input
                                type="text"
                                value={localURL}
                                onChange={(e) =>
                                  handleInputChange(e, setLocalURL)
                                }
                                onBlur={updateGlobalState}
                                disabled={!editing}
                                className="summary-box"
                              />
                            </div>
                            <div></div>
                          </div>
                        </div>
                      )}
                      {!editing ? (
                        <div className="comment-container">
                          <div className="comment-content">
                            {customDesc && customDesc.length > 0 ? (
                              <ul>
                                {customDesc
                                  .split("\n\n")
                                  .map((bullet, index) => (
                                    <li
                                      key={index}
                                      className={error ? "error" : "mb-2"}
                                    >
                                      {bullet}
                                    </li>
                                  ))}
                              </ul>
                            ) : (
                              <p className={error ? "error" : "desc"}>{desc}</p>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="comment-container flow">
                          <textarea
                            className="desc edit-textarea"
                            value={customDesc}
                            onBlur={updateSummary}
                            onChange={handleChange}
                          />
                        </div>
                      )}
                    </div>
                    <div className="save-actions">
                      <div />
                      <div className="flex-btn mt-2">
                        {desc && !error && (
                          <>
                            <div className="flex-button button-group">
                              <div className="flex">
                                {/* <ButtonPrimary
                                  className="mr-2 grey"
                                  outline
                                  text="Regenerate"
                                  onClick={handleRegenerate}
                                /> */}
                                <Tooltip title={tooltipTitle}>
                                  <button
                                    id="tooltipButton"
                                    className="btn-copy outlined mr-2"
                                    onClick={handleCopy}
                                    onMouseOut={handleMouseOut}
                                  >
                                    <p>Copy</p>
                                  </button>
                                </Tooltip>
                                <button
                                  id="tooltipButton"
                                  className="btn-copy outlined mr-2"
                                  onClick={() => {
                                    setDesc(desc);
                                    handleCustomDescChange();
                                    setEditing(!editing);
                                  }}
                                >
                                  <p>Edit</p>
                                </button>
                              </div>
                              <ButtonPrimary
                                text="Save"
                                className="close"
                                onClick={handleSave}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
        )}

        {calendarPopup && (
          <DateComponent
            setCalendarPopup={setCalendarPopup}
            reqDate={reqDate}
            setDate={setDate}
            requiredDates={0}
          />
        )}
      </>
    )
  );
};

export default Summarize;
